'use client'

import { Box } from '@mui/joy'
import { pxToRem } from '@ui/style/muiTheme'

type AsideArticlesWrapperProps = {
	children: React.ReactNode
}

const AsideArticlesWrapper = ({ children }: AsideArticlesWrapperProps) => {
	return (
		<Box
			display="flex"
			flexDirection="column"
			sx={{
				marginTop: {
					xs: pxToRem(-48),
					md: pxToRem(-64),
					lg: pxToRem(-48),
				},
				'&>*': {
					marginTop: {
						xs: pxToRem(48),
						md: pxToRem(64),
						lg: pxToRem(48),
					},
				},
			}}
		>
			{children}
		</Box>
	)
}

export default AsideArticlesWrapper
